import * as React from 'react';

type PhoneProps = {
  size?: number;
  color?: string;
};

export function Phone({
  size = 18,
  color = '#191F2E',
}: PhoneProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.11061 1.49455C3.82886 1.13231 3.29338 1.09897 2.96888 1.42347L1.80572 2.58663C1.2618 3.13054 1.06185 3.90111 1.29949 4.57703C2.2538 7.29139 3.81617 9.84005 5.98806 12.0119C8.15995 14.1838 10.7086 15.7462 13.423 16.7005C14.0989 16.9381 14.8695 16.7382 15.4134 16.1943L16.5765 15.0311C16.901 14.7066 16.8677 14.1711 16.5054 13.8894L13.911 11.8715C13.7259 11.7275 13.485 11.6767 13.2575 11.7335L10.7948 12.3492C10.1259 12.5164 9.41831 12.3204 8.93076 11.8329L6.16711 9.06925C5.67955 8.58169 5.48356 7.87408 5.65079 7.20517L6.26646 4.74247C6.32332 4.51503 6.27246 4.27407 6.12853 4.08902L4.11061 1.49455ZM2.12037 0.57496C2.95525 -0.259918 4.33293 -0.174147 5.05781 0.757839L7.07573 3.3523C7.44604 3.82842 7.5769 4.44835 7.4306 5.0335L6.81493 7.4962C6.74993 7.7562 6.82611 8.03123 7.01561 8.22074L9.77927 10.9844C9.96877 11.1739 10.2438 11.2501 10.5038 11.1851L12.9665 10.5694C13.5517 10.4231 14.1716 10.554 14.6477 10.9243L17.2422 12.9422C18.1741 13.6671 18.2599 15.0448 17.425 15.8796L16.2619 17.0428C15.4297 17.875 14.185 18.2404 13.025 17.8326C10.1447 16.8199 7.44118 15.1621 5.13955 12.8604C2.83792 10.5588 1.18007 7.85526 0.167443 4.97503C-0.240393 3.81501 0.125021 2.57031 0.957206 1.73812L2.12037 0.57496Z"
        fill={color}
      />
    </svg>
  );
}
